import { hooks as commonHooks } from '@sitebuilder/common';
import { View } from './utils';

interface PropsShape {
    options: View[];
    selected: string;
    onChange: (selectedOption: string) => void;
    dataContext: any;
    hideTabHeader: boolean;
}

export default function ViewTabs(props: PropsShape) {
    const handleChange = (selectedOption: View) => {
        props.onChange(selectedOption.id);
    };

    const handleOnKeyPress = (e: React.KeyboardEvent<HTMLElement>, selectedOption: View) => {
        if (e.key === 'Enter') {
            props.onChange(selectedOption.id);
        }
    };

    const i18n = commonHooks.useLocalization();

    return (
        <>
            {(!props.hideTabHeader || props.options.length >= 2) && (
                <div className={`view-tabs-wrapper sticky-header`} role={'tablist'}>
                    {props.options.map((o: View) => (
                        <div
                            className={`view-tab ${props.selected === o.id ? 'selected' : ''}`}
                            key={o.id}
                            onClick={() => handleChange(o)}
                            onKeyPress={(e) => handleOnKeyPress(e, o)}
                            tabIndex={0}
                            role={'tab'}
                            aria-selected={props.selected === o.id}
                        >
                            {i18n.format(o.label, props.dataContext)}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}
